import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Alert, Button, CircularProgress, Stack, Typography } from '@mui/material';

import axiosInstance from '../../../axiosInstance';
import EcranAuth from '../../../components/Auth/EcranAuth';

/**
 * Activation du compte depuis le lien reçu par email.
 *
 * L'écran précédent n'affichait qu'un message brut, sans rien pour continuer :
 * celui qui venait d'activer son compte restait dans une impasse.
 */
const ActivateAccount = () => {
  const { uidb64, token } = useParams();
  const [etat, setEtat] = useState('attente');
  const [message, setMessage] = useState('');

  useEffect(() => {
    axiosInstance.get(`/activate/${uidb64}/${token}/`)
      .then((reponse) => {
        setMessage(reponse.data.message || '');
        setEtat('ok');
      })
      .catch((error) => {
        setMessage(error.response?.data?.error
          || "Ce lien d'activation n'est plus valable.");
        setEtat('echec');
      });
  }, [uidb64, token]);

  if (etat === 'attente') {
    return (
      <EcranAuth titre="Activation en cours">
        <Stack spacing={2} alignItems="center" sx={{ py: 2 }}>
          <CircularProgress />
          <Typography variant="body2" color="text.secondary">
            Un instant, nous vérifions votre lien.
          </Typography>
        </Stack>
      </EcranAuth>
    );
  }

  if (etat === 'ok') {
    return (
      <EcranAuth titre="Compte activé">
        <Stack spacing={3}>
          <Alert severity="success">
            {message || 'Votre compte est activé. Vous pouvez vous connecter.'}
          </Alert>
          <Button component={Link} to="/login" variant="contained" size="large">
            Se connecter
          </Button>
        </Stack>
      </EcranAuth>
    );
  }

  return (
    <EcranAuth titre="Activation impossible">
      <Stack spacing={3}>
        <Alert severity="error">{message}</Alert>
        <Typography variant="body2" color="text.secondary">
          Un lien d'activation ne sert qu'une fois. Si votre compte est déjà
          activé, connectez-vous simplement.
        </Typography>
        <Button component={Link} to="/login" variant="outlined">
          Aller à la connexion
        </Button>
      </Stack>
    </EcranAuth>
  );
};

export default ActivateAccount;
